export default "__VITE_ASSET__DuDm8QR2__"